import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../../../reducers';

const sliceSelector = (state: StorageState) => state.users.users.active;

export const accessActiveUserRulesSelector = () => createSelector(sliceSelector, state => state.accessRules);

export const accessActiveUserSelector = () => createSelector(sliceSelector, state => state.user);

export const accessActiveUserRegions = () => createSelector(sliceSelector, state => state.user?.regions);
